import React from 'react'
import Link from 'gatsby-link'
import { siteMetadata } from '../../gatsby-config'
import SiteNavi from '../components/SiteNavi'
import emergence from 'emergence.js'

import './gatstrap.scss'
import 'animate.css/animate.css'
import 'prismjs/themes/prism-okaidia.css'
import 'devicon-2.2/devicon.min.css'
import 'font-awesome/css/font-awesome.css'

class Template extends React.Component {
  componentDidMount() {
    emergence.init()
  }

  componentDidUpdate() {
    emergence.init()
  }

  render() {
    const { location, children } = this.props
    return (
      <div>
        {location.pathname === '/' && <ImageHeader />}
        {location.pathname !== '/' && (
          <SiteNavi title={siteMetadata.title} {...this.props} />
        )}
        {children()}
      </div>
    )
  }
}

const ImageHeader = () => (
  <div className="img-wrapper text-center">
    <img
      src={`/img/cover.jpg`}
      alt="Христос и самарянка"
      className="header-img img-responsive"
    />
    <div className="overText">
      <h1 className="headerText">Сборник духовных стихов</h1>
      <h2 className="secondaryText">
        Русская Православная Старообрядческая Церковь
      </h2>
    </div>
  </div>
)

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.js